export default __webpack_public_path__ + "static/media/bannerImage.59161d68.png";